/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Service_CreativeInputs */

const en_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creative Services`)
};

const es_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios creativos`)
};

const fr_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services créatifs`)
};

const de_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreativdienstleistungen`)
};

const ja_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイティブサービス`)
};

const zh_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创意服务`)
};

const ar_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خدمات إبداعية`)
};

const id_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layanan Kreatif`)
};

const it_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servizi Creativi`)
};

const ru_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Творческие услуги`)
};

const pt_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviços Criativos`)
};

const ko_listing_category_service_creative = /** @type {(inputs: Listing_Category_Service_CreativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이티브 서비스`)
};

/**
* | output |
* | --- |
* | "Creative Services" |
*
* @param {Listing_Category_Service_CreativeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_service_creative = /** @type {((inputs?: Listing_Category_Service_CreativeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Service_CreativeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_service_creative(inputs)
	if (locale === "es") return es_listing_category_service_creative(inputs)
	if (locale === "fr") return fr_listing_category_service_creative(inputs)
	if (locale === "de") return de_listing_category_service_creative(inputs)
	if (locale === "ja") return ja_listing_category_service_creative(inputs)
	if (locale === "zh") return zh_listing_category_service_creative(inputs)
	if (locale === "ar") return ar_listing_category_service_creative(inputs)
	if (locale === "id") return id_listing_category_service_creative(inputs)
	if (locale === "it") return it_listing_category_service_creative(inputs)
	if (locale === "ru") return ru_listing_category_service_creative(inputs)
	if (locale === "pt") return pt_listing_category_service_creative(inputs)
	return ko_listing_category_service_creative(inputs)
});